<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\changePassManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tài khoản bên cạnh ảnh đại diện, rồi nhấn vào icon [Thông tin cá nhân].</p>
                </div>
                <div><img src="/static\images\vi\newManual\changePassManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhấn vào thanh [Đổi mật khẩu] ở bên phải màn hình.</p>
                    <p>③ Sau khi nhập vào các ô [Mật khẩu hiện tại], [Mật khẩu mới], [Mật khẩu mới (Xác nhận)], rồi nhấn nút [Lưu mật khẩu].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn icon Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên trái màn hình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\change_pass_1.png" alt="" /></div>
                <div><p>② Nhấn vào nút [Thông tin cá nhân].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\change_pass_2.png" alt="" /></div>
                <div><p>③ Nhấn vào nút [Đổi mật khẩu], xuất hiện phần thay đổi mật khẩu.</p></div>
                <div><p>④ Nhập đúng thông tin vào ô [Mật khẩu hiện tại], [Mật khẩu mới], [Mật khẩu mới(xác nhận)] và bấm nút [lưu mật khẩu]. Ví dụ đổi mật khẩu: Zse4rfvgy7.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\change_pass_3.png" alt="" /></div>
                <div><p>⑤ Xuất hiện thông báo thay đổi mật khẩu thành công.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\change_pass_5.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/changePass_manual.vue